import { ReactElement } from "react";
import styles from "./styles.module.css";
import { Equipamento } from "../../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";

type Props = {
  metaIndex: number;
  itemObj: Equipamento;
  children?: React.JSX.Element;
};

const RowEquipamento = ({ metaIndex, itemObj, children }: Props) => {
  return (
    <tr className={styles.row}>
      <td className={styles.dozeAvos}>{metaIndex + 1}</td>
      <td>{itemObj.nome_especificacao}</td>
      <td className={styles.sexto}>{itemObj.quantidade}</td>
      <td className={styles.sexto}>{itemObj.valor_unidade}</td>
      <td className={styles.sexto}>{itemObj.valor_total}</td>
      {children && <td className={styles.btncoll}>{children}</td>}
    </tr>
  );
};
export default RowEquipamento;
